/* Quick Add panel: opens from [data-quick-add-trigger="product-handle"],
   fills itself via the Section Rendering API, posts through Liquid Ajax Cart. */
(() => {
  const section = document.getElementById("shopify-section-quick-add");
  if (!section) return;

  const content = section.querySelector("[data-quick-add-content]");
  const panel = section.querySelector(".quick-add__panel");
  const OPEN_CLASS = "js-quick-add-open";
  let lastTrigger = null;

  const setInert = (on) =>
    [...section.closest(".page-content").children].forEach((el) => el !== section && (el.inert = on));

  function open() {
    document.body.classList.add(OPEN_CLASS);
    setInert(true);
    panel.focus();
  }

  function close() {
    document.body.classList.remove(OPEN_CLASS);
    setInert(false);
    if (lastTrigger) lastTrigger.focus();
    lastTrigger = null;
  }

  async function load(handle, variantId) {
    const variant = variantId ? `&variant=${variantId}` : "";
    const res = await fetch(`/products/${handle}?section_id=quick-add${variant}`);
    if (!res.ok) throw new Error(`Quick add fetch failed: ${res.status}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const fetched = doc.querySelector("[data-quick-add-content]");
    if (!fetched) throw new Error("Quick add content missing in response");
    content.innerHTML = fetched.innerHTML;
    if (content.querySelector("[data-qa-bundle]")) await loadBundle(handle);
    if (typeof syncPurchase === "function") syncPurchase(content);
    if (typeof syncLimitOne === "function") syncLimitOne(content);
    if (typeof lazyLoadInstance !== "undefined") lazyLoadInstance.update();
  }

  /* Bundle picks, taken from the full PDP */
  async function loadBundle(handle) {
    const res = await fetch(`/products/${handle}`);
    if (!res.ok) throw new Error(`Bundle fetch failed: ${res.status}`);
    const doc = new DOMParser().parseFromString(await res.text(), "text/html");
    const bundle = doc.querySelector("[data-bundle]");
    if (!bundle?.querySelector("[data-bundle-pick]")) throw new Error("Bundle picks missing");

    // Avoid id clashes on a PDP
    bundle.querySelectorAll("[id]").forEach((el) => (el.id = `qa-${el.id}`));
    bundle.querySelectorAll("[for]").forEach((el) => el.setAttribute("for", `qa-${el.getAttribute("for")}`));
    content.querySelector("[data-qa-bundle]").append(document.importNode(bundle, true));
    syncBundle();
  }

  function currentVariant() {
    const dataEl = section.querySelector("[data-qa-variants]");
    const id = section.querySelector("[data-qa-id]")?.value;
    return dataEl && JSON.parse(dataEl.textContent).find((v) => String(v.id) === id);
  }

  function syncBundle() {
    const bundle = content.querySelector("[data-bundle]");
    const variant = currentVariant();
    if (!bundle || !variant) return;

    bundle.querySelectorAll("[data-bundle-parent]").forEach((input) => (input.value = variant.id));
    const base = parseInt(bundle.dataset.bundleBase, 10) || 0;
    const uplift = [...bundle.querySelectorAll("[data-bundle-pick]")].reduce(
      (sum, select) => sum + Math.max(0, (parseInt(select.selectedOptions[0]?.dataset.price, 10) || 0) - base),
      0,
    );
    const price = ProductPage.formatCents(variant.cents + uplift, bundle.dataset.moneyFormat);
    section.querySelector("[data-qa-price]").textContent = price;
    const headingPrice = section.querySelector("[data-qa-heading-price]");
    if (headingPrice) headingPrice.textContent = price;
    section.querySelector(".quick-add__submit").disabled = !variant.available;
  }

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-quick-add-trigger]");
    if (trigger) {
      e.preventDefault();
      lastTrigger = trigger;
      const handle = trigger.getAttribute("data-quick-add-trigger");
      const variantId = trigger.getAttribute("data-quick-add-variant");
      load(handle, variantId)
        .then(open)
        .catch(() => {
          // fall back to the PDP if the panel can't load
          window.location.href = `/products/${handle}${variantId ? `?variant=${variantId}` : ""}`;
        });
      return;
    }

    if (e.target.closest("[data-quick-add-close]")) close();

    const stepper = e.target.closest("[data-qa-minus], [data-qa-plus]");
    if (stepper && section.contains(stepper)) {
      const input = section.querySelector('input[name="quantity"]');
      if (!input) return;
      const delta = stepper.hasAttribute("data-qa-plus") ? 1 : -1;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && document.body.classList.contains(OPEN_CLASS)) close();
  });

  /* Variant pills → resolve variant, update id input + prices + availability */
  section.addEventListener("change", (e) => {
    if (!e.target.matches('[name^="qa-option-"]')) return;
    const dataEl = section.querySelector("[data-qa-variants]");
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const selected = [...section.querySelectorAll("[data-qa-group]")].map(
      (group) => group.querySelector("input:checked")?.value
    );
    const match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    if (!match) return;

    section.querySelector("[data-qa-id]").value = match.id;
    section.querySelector("[data-qa-price]").textContent = match.price;
    const img = section.querySelector("[data-qa-media] img");
    if (img && match.image) {
      img.removeAttribute("srcset");
      img.src = match.image;
    }
    const headingPrice = section.querySelector("[data-qa-heading-price]");
    if (headingPrice) headingPrice.textContent = match.price;
    const submit = section.querySelector(".quick-add__submit");
    submit.disabled = !match.available;
    section.querySelector("[data-qa-label]").textContent = match.available ? "Add to Bag" : "Sold Out";
    syncBundle();
    if (typeof syncPurchase === "function") syncPurchase(content);
    if (typeof syncLimitOne === "function") syncLimitOne(content);
  });

  section.addEventListener("change", (e) => {
    if (e.target.matches("[data-bundle-pick]")) syncBundle();
  });

  section.addEventListener(
    "submit",
    (e) => {
      const uid = e.target.querySelector("[data-bundle-uid]");
      if (uid) uid.value = ProductPage.bundleLabel(e.target);
    },
    true,
  );

  /* Close the panel once its form has added successfully (cart drawer opens via main.js) */
  if (typeof liquidAjaxCart !== "undefined") {
    liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
      if (state.requestType !== "add") return;
      if (!section.contains(state.info?.initiator)) return;
      subscribeToResult((result) => {
        if (result.responseData?.ok) close();
      });
    });
  }
})();
